import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import WizardStepLayout from '../../components/common/WizardStepLayout';
import EmbeddedWizard from '../../embedded/wizard/EmbeddedWizard';
import styles from './ConfigurationStep.module.scss';
import { useLocalizedMessage } from '../../../../util/useLocalizedMessage';

/**
 * Configuration Step - hosts embedded wizard for component configuration
 * This step is shown after experience selection and contains sub-steps
 */
const ConfigurationStep = React.forwardRef(({
  data,
  onReady,
  onComplete,
  onNavigationChange,
  shopId,
  client,
}, ref) => {
  const localizeMessage = useLocalizedMessage();
  const selectedExperience = data?.selectedExperience;
  const experienceType = selectedExperience;
  const [isExpanded, setIsExpanded] = useState(false);

  if (!experienceType) {
    return (
      <WizardStepLayout>
        <Box className={styles.emptyState}>
          <p>{localizeMessage('wizard.searchSetup.configuration.selectFirst')}</p>
        </Box>
      </WizardStepLayout>
    );
  }

  return (
    <WizardStepLayout maxWidth="wide" noMaxWidth>
      <Box className={styles.configContainer}>
        <EmbeddedWizard
          ref={ref}
          experienceType={experienceType}
          shopId={shopId}
          client={client}
          onComplete={onComplete}
          onReady={onReady}
          onNavigationChange={onNavigationChange}
          isExpanded={isExpanded}
          onExpandToggle={() => setIsExpanded(current => !current)}
        />
      </Box>
    </WizardStepLayout>
  );
});

ConfigurationStep.displayName = 'ConfigurationStep';

ConfigurationStep.propTypes = {
  shopId: PropTypes.string.isRequired,
  data: PropTypes.shape({
    selectedExperience: PropTypes.string,
  }),
  onReady: PropTypes.func,
  onComplete: PropTypes.func,
  onNavigationChange: PropTypes.func,
  client: PropTypes.shape({
    loadSearchExperienceConfig: PropTypes.func,
    saveSearchExperienceConfig: PropTypes.func,
  }),
};

ConfigurationStep.defaultProps = {
  data: {},
  onReady: null,
  onComplete: null,
  onNavigationChange: null,
  client: null,
};

export default ConfigurationStep;
